import React, { useState, useEffect } from "react";
import { Card, Button, Form } from "react-bootstrap";
import { InputPic } from "../../../../_metronic/_partials/components/utils/InputPic";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import { useFormik } from "formik";
import * as yup from "yup";
import { useSelector, shallowEqual } from "react-redux";
import * as apiProdotti from "../../../api/prodotti";
import * as apiCampione from "../../../api/campioni";
import * as apiMateriale from "../../../api/materiali";
import * as apiTarget from "../../../api/target"; // API target
import Select from "react-select";
import { icons } from "../../../config/config";
import { min } from "lodash";
import { multiSelectProps } from "../../../utils/selectStyles";

// Import rimangono uguali...

const validationSchema = yup.object({
  name: yup
    .string("Inserire un nome valido")
    .required("Inserire un nome valido")
    .min(3, "Minimo tre caratteri")
    .max(50, "Massimo cinquanta caratteri"),
  qta: yup
    .string("Inserire una quantità valida")
    .min(0, "Minimo tre caratteri")
    .max(20, "Massimo venti caratteri"),
  sku: yup
    .string("Inserire uno SKU valido")
    .min(3, "Minimo tre caratteri")
    .max(20, "Massimo venti caratteri")
    .required("Inserire uno SKU valido"),
  description: yup
    .string("Inserire una descrizione valida")
    .notRequired()
    .min(3, "Minimo tre caratteri")
    .max(500, "Massimo cento caratteri"),
  division: yup
    .number("Selezionare un'azienda")
    .positive("Selezionare un'azienda")
    .required("Selezionare un'azienda"),
  cost: yup
    .number("Inserire un costo valido")
    .required("Inserire un costo valido")
    .positive("Inserire un costo valido"),
  targets: yup
    .array()
    .min(1, "Selezionare almeno un target")
    .required("Selezionare almeno un target"),
  samples: yup
    .array()
    .min(0)
    .required("Selezionare almeno un campione")
    .default([]),
  materials: yup
    .array()
    .min(0)
    .default([]),
});

const actionsMessages = {
  new: "Crea",
  edit: "Modifica",
  removeImage: "Rimuovi Immagine",
  reset: "Reset",
};

const formFields = {
  name: { label: "Nome prodotto", placeholder: "Nome prodotto..." },
  qta: { label: "Quantità", placeholder: "100ml" },
  sku: { label: "SKU", placeholder: "sku" },
  description: {
    label: "Descrizione prodotto",
    placeholder: "Descrizione...",
    rows: 3,
  },
  division: { label: "Selezionare azienda", placeholder: "Azienda..." },
  cost: { label: "Costo (€)", placeholder: "Costo..." },
  iva: { label: "Iva (%)", placeholder: "22%" },
  image: { label: "Immagine" },
  targets: { label: "Selezionare il target", placeholder: "Target..." },
};

const divisionOptions = [
  { value: 0, label: "Seleziona azienda" },
  { value: 1, label: "Roypet" },
  { value: 2, label: "Roydermal" },
  { value: 11, label: "Valderma" },
];

const Toolbar = ({
  submitCallback,
  resetImmagineCallback,
  resetCallback,
  closeCallback,
  loading,
  alreadyExisting,
  ...props
}) => {
  return (
    <div {...props}>
      <Button disabled={loading} onClick={submitCallback} className="my-1 ml-2 d-inline-flex align-items-center">
        <span className="svg-icon svg-icon-md svg-icon-light-primary">
          <SVG src={toAbsoluteUrl(icons.ok)} />
        </span>
        {alreadyExisting ? actionsMessages.edit : actionsMessages.new}
      </Button>
      {resetImmagineCallback && (
        <Button disabled={loading} onClick={resetImmagineCallback} variant="danger" className="my-1 ml-2 d-inline-flex align-items-center">
          <span className="svg-icon svg-icon-md svg-icon-light-primary">
            <SVG src={toAbsoluteUrl(icons.close)} />
          </span>
          {actionsMessages.removeImage}
        </Button>
      )}
      <Button disabled={loading} onClick={resetCallback} variant="secondary" className="my-1 ml-2 d-inline-flex align-items-center">
        <span className="svg-icon svg-icon-md svg-icon-secondary">
          <SVG src={toAbsoluteUrl(icons.reset)} />
        </span>
        {actionsMessages.reset}
      </Button>
      <Button onClick={closeCallback} variant="secondary" className="my-1 ml-2 d-inline-flex align-items-center">
        <span className="svg-icon svg-icon-md svg-icon-secondary">
          <SVG src={toAbsoluteUrl(icons.go_back)} />
        </span>
        Prodotti
      </Button>
    </div>
  );
};

export const EditNewProdotto = (props) => {
  const [loading, setLoading] = useState(false);
  const [image, setImage] = useState(false);
  const [targetOptions, setTargetOptions] = useState([]);

  const [sampleOptions, setSampleOptions] = useState([]);

  const [materialOptions, setMaterialOptions] = useState([]);

  const user = useSelector((state) => state.auth.user, shallowEqual);
  const alreadyExisting = props.prodotto !== false;

  // Inizializza i valori del form una sola volta
  const getInitialValues = () => {
    const defaults = {
      name: "",
      sku: "",
      description: "",
      division: 0,
      cost: "",
      iva: 22,
      targets: [],
      samples: [],
      materials: [],
    };

    if (alreadyExisting) {
      const prodotto = props.prodotto;
      return {
        ...defaults,
        name: prodotto.name || "",
        qta: prodotto.qta || "",
        sku: prodotto.sku || "",
        description: prodotto.description || "",
        division: prodotto.division || 0,
        cost: prodotto.price || prodotto.cost || "",
        iva: prodotto.iva || 22,
        targets: [],
        samples: [],
        materials: [],
      };
    }

    return defaults;
  };

  const formik = useFormik({
    initialValues: getInitialValues(),
    validationSchema: validationSchema,
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      setLoading(true);

      try {
        const result = new FormData();
        result.append("id", alreadyExisting ? props.prodotto.id : "");
        result.append("name", values.name);
        result.append("qta", values.qta);
        result.append("sku", values.sku);
        result.append("azienda", values.division);
        result.append("descrizione", values.description);
        result.append("price", parseFloat(values.cost));
        result.append("iva", parseFloat(values.iva));
        result.append("accessToken", user.authToken);

        if (image !== false) result.append("image", image);

        // Aggiungi i target selezionati
        values.targets.forEach((target) => {
          result.append("targets[]", target.value);
        });

        // Campioni
        values.samples.forEach((sample) => {
          result.append("samples[]", sample.value);
        });

        values.materials.forEach((material) => {
          result.append("materials[]", material.value);
        });
        
        await apiProdotti.add(result);
        props.triggerServerUpdate();
        props.hideEditPage();
      } catch (error) {
        setStatus(error.message);
      } finally {
        setLoading(false);
        setSubmitting(false);
      }
    },
  });

  // Funzione per ottenere i target iniziali
  const getInitialTargets = (options) => {
    if (!alreadyExisting || !props.prodotto.targets) return [];

    let targetIds = props.prodotto.targets;
    if (typeof targetIds === "string") {
      targetIds = targetIds.split(",").map(Number);
    }
    if (!Array.isArray(targetIds)) {
      targetIds = [targetIds];
    }

    return options.filter((opt) => targetIds.includes(opt.value));
  };

  const getInitialSamples = (options) => {
    if (!alreadyExisting || !props.prodotto.samples) return [];

    let sampleSkus = props.prodotto.samples;
    if (typeof sampleSkus === "string") {
      sampleSkus = sampleSkus.split(",").map(String);
    }
    if (!Array.isArray(sampleSkus)) {
      sampleSkus = [sampleSkus];
    }
    return options.filter((opt) => sampleSkus.includes(opt.value));
  };

  const getInitialMaterials = (options) => {
    if (!alreadyExisting || !props.prodotto.materials) return [];

    let materialSkus = props.prodotto.materials;
    if (typeof materialSkus === "string") {
      materialSkus = materialSkus.split(",").map(String);
    }
    if (!Array.isArray(materialSkus)) {
      materialSkus = [materialSkus];
    }
    return options.filter((opt) => materialSkus.includes(opt.value));
  };

  useEffect(() => {
    const loadSamples = async () => {
      //try {
      const data = await apiCampione.getAll(user.authToken); // Implementa questa API
      const options = data.map((sample) => ({
        value: sample.sku,
        label: `${sample.sku} ${sample.name}`,
      }));
      setSampleOptions(options);
      // Se siamo in modifica, carica quelli già associati
      const initialSamples = getInitialSamples(options);
      formik.setFieldValue("samples", initialSamples);
      // if (alreadyExisting && props.prodotto.samples) {
      //   let selectedIds = props.prodotto.samples;
      //   if (typeof selectedIds === "string") {
      //     selectedIds = selectedIds.split(",").map(Number);
      //   }
      //   const selectedSamples = options.filter((opt) =>
      //     selectedIds.includes(opt.value)
      //   );
      //   formik.setFieldValue("samples", selectedSamples);
      // }
      // } catch (error) {
      //   console.error("Errore caricamento campioni:", error);
      // }
    };
    loadSamples();
  }, [user.authToken, props.prodotto]);

  // Carica le opzioni dei target e imposta i target selezionati
  useEffect(() => {
    const loadTargetData = async () => {
      try {
        const data = await apiTarget.getAll(user.authToken);
        const options = data.map((target) => ({
          value: target.id,
          label: target.name,
        }));
        setTargetOptions(options);

        // Se stiamo modificando un prodotto esistente, imposta i target selezionati
        const initialTargets = getInitialTargets(options);
        formik.setFieldValue("targets", initialTargets);
      } catch (error) {
        console.error("Errore caricamento target:", error);
      }
    };

    loadTargetData();
  }, [user.authToken, props.prodotto]);

  useEffect(() => {
    const loadMaterials = async () => {
      //try {
      const data = await apiMateriale.getAll(user.authToken); // Implementa questa API
      const options = data.map((material) => ({
        value: material.sku,
        label: `${material.sku} ${material.name}`,
      }));
      setMaterialOptions(options);
      // Se siamo in modifica, carica quelli già associati
      const initialMaterials = getInitialMaterials(options);
      formik.setFieldValue("materials", initialMaterials);
      // } catch (error) {
      //   console.error("Errore caricamento materiale:", error);
      // }
    };
    loadMaterials();
  }, [user.authToken, props.prodotto]);

  // Imposta l'immagine iniziale
  useEffect(() => {
    if (alreadyExisting && props.prodotto.image) {
      setImage(props.prodotto.image);
    }
  }, [alreadyExisting, props.prodotto]);

  const handleReset = () => {
    const initialValues = getInitialValues();
    const initialTargets = getInitialTargets(targetOptions);
    const initialSamples = getInitialSamples(sampleOptions);
    const initialMaterials = getInitialMaterials(materialOptions);

    formik.resetForm({
      values: {
        ...initialValues,
        targets: initialTargets,
        samples: initialSamples,
        materials: initialMaterials,
      },
    });
    setImage(alreadyExisting ? props.prodotto.image : false);
  };

  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) return "is-invalid";
    if (formik.touched[fieldname] && !formik.errors[fieldname]) return "is-valid";
  };

  const handleTargetsChange = (selectedTargets) => {
    formik.setFieldValue("targets", selectedTargets || []);
  };

  const handleSamplesChange = (selectedSamples) => {
    formik.setFieldValue("samples", selectedSamples || []);
  };

  const handleMaterialsChange = (selectedMaterials) => {
    formik.setFieldValue("materials", selectedMaterials || []);
  };

  return (
    <Card className="card-custom gutter-b">
      <Card.Header className="border-0 py-5 row">
        <Card.Title className="float-left col-auto">
          <h3 className="font-weight-bolder text-dark">
            {alreadyExisting ? `${actionsMessages.edit} prodotto` : `${actionsMessages.new} prodotto`}
          </h3>
        </Card.Title>
        <Toolbar
          submitCallback={formik.handleSubmit}
          resetImmagineCallback={image ? () => setImage(false) : null}
          resetCallback={handleReset}
          closeCallback={props.hideEditPage}
          loading={loading}
          alreadyExisting={alreadyExisting}
          className="float-right col-auto"
        />
      </Card.Header>
      <Card.Body className="pt-0">
        <Form className="row">
          {formik.status && (
            <div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
              <div className="alert-text font-weight-bold">{formik.status}</div>
            </div>
          )}

          <Form.Group className="col-xl-4 col-lg-4 col-sm-12 pr-1">
            <Form.Label className="col-12">{formFields.name.label}</Form.Label>
            <Form.Control
              type="text"
              name="name"
              placeholder={formFields.name.placeholder}
              className={getInputClasses("name")}
              {...formik.getFieldProps("name")}
            />
            {formik.touched.name && formik.errors.name && (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block">{formik.errors.name}</div>
              </div>
            )}
          </Form.Group>

          <Form.Group className="col-xl-2 col-lg-2 col-sm-12 pr-1 pl-1">
            <Form.Label className="col-12">{formFields.qta.label}</Form.Label>
            <Form.Control
              type="text"
              name="qta"
              placeholder={formFields.qta.placeholder}
              className={getInputClasses("qta")}
              {...formik.getFieldProps("qta")}
            />
            {formik.touched.qta && formik.errors.qta && (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block">{formik.errors.name}</div>
              </div>
            )}
          </Form.Group>

          <Form.Group className="col-xl-2 col-lg-2 col-sm-12 pr-1 pl-1">
            <Form.Label className="col-12">{formFields.sku.label}</Form.Label>
            <Form.Control
              type="text"
              name="sku"
              placeholder={formFields.sku.placeholder}
              className={getInputClasses("sku")}
              {...formik.getFieldProps("sku")}
            />
            {formik.touched.sku && formik.errors.sku && (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block">{formik.errors.name}</div>
              </div>
            )}
          </Form.Group>

          <Form.Group className="col-xl-2 col-lg-2 col-sm-12 pr-1 pl-1">
            <Form.Label className="col-12">{formFields.cost.label}</Form.Label>
            <Form.Control
              type="number"
              name="cost"
              placeholder={formFields.cost.placeholder}
              className={getInputClasses("cost")}
              {...formik.getFieldProps("cost")}
            />
            {formik.touched.cost && formik.errors.cost && (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block">{formik.errors.cost}</div>
              </div>
            )}
          </Form.Group>

          <Form.Group className="col-xl-2 col-lg-2 col-sm-12 pl-1">
            <Form.Label className="col-12">{formFields.iva.label}</Form.Label>
            <Form.Control
              type="number"
              name="iva"
              placeholder={formFields.iva.placeholder}
              className={getInputClasses("iva")}
              {...formik.getFieldProps("iva")}
            />
            {formik.touched.iva && formik.errors.iva && (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block">{formik.errors.iva}</div>
              </div>
            )}
          </Form.Group>

          <Form.Group className="col-xl-6 col-lg-6 col-sm-12">
            <Form.Label className="col-12">{formFields.division.label}</Form.Label>
            <select
              name="division"
              className={`form-control ${getInputClasses("division")}`}
              {...formik.getFieldProps("division")}
            >
              {divisionOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
            {formik.touched.division && formik.errors.division && (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block">{formik.errors.division}</div>
              </div>
            )}
          </Form.Group>

          <Form.Group className="col-xl-6 col-lg-6 col-sm-12">
            <Form.Label className="col-12">{formFields.image.label}</Form.Label>
            <InputPic
              name="productPic"
              id="productPic"
              pic={typeof image === "string" ? { name: image.split("/").slice(-1) } : image}
              setPic={setImage}
            />
          </Form.Group>

          <Form.Group className="col-xl-6 col-lg-6 col-sm-12">
            <Form.Label className="col-12">{formFields.targets.label}</Form.Label>
            <Select
              {...multiSelectProps}
              options={targetOptions}
              value={formik.values.targets}
              onChange={handleTargetsChange}
              placeholder="Seleziona i target..."
            />
            {formik.touched.targets && formik.errors.targets && (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block">{formik.errors.targets}</div>
              </div>
            )}
          </Form.Group>

          <Form.Group className="col-xl-6 col-lg-6 col-sm-12">
            <Form.Label className="col-12">Seleziona materiale</Form.Label>
            <Select
              isMulti
              options={materialOptions}
              value={formik.values.materials}
              onChange={handleMaterialsChange}
              placeholder="Seleziona i materiali..."
            />
            {formik.touched.materials && formik.errors.materials && (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block">{formik.errors.materials}</div>
              </div>
            )}
          </Form.Group>

          <Form.Group className="col-xl-6 col-lg-6 col-sm-12" style={{zIndex: 99}}>
            <Form.Label className="col-12">Seleziona campioni</Form.Label>
            <Select
              isMulti
              options={sampleOptions}
              value={formik.values.samples}
              onChange={handleSamplesChange}
              placeholder="Seleziona i campioni..."
            />
            {formik.touched.samples && formik.errors.samples && (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block">{formik.errors.samples}</div>
              </div>
            )}
          </Form.Group>          

          <Form.Group className="col-12">
            <Form.Label className="col-12">{formFields.description.label}</Form.Label>
            <Form.Control
              as="textarea"
              name="description"
              placeholder={formFields.description.placeholder}
              rows={formFields.description.rows}
              style={{ resize: "none" }}
              className={getInputClasses("description")}
              {...formik.getFieldProps("description")}
            />
            {formik.touched.description && formik.errors.description && (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block">{formik.errors.description}</div>
              </div>
            )}
          </Form.Group>
        </Form>
      </Card.Body>
    </Card>
  );
};
